export const TERMS_AND_CONDITIONS_PATH = 'terms-of-service';
export const PRIVACY_POLICY_PATH = 'privacy-policy';
export const LOGIN_PATH = 'login';
export const REGISTER_PATH = 'register';
export const VERIFY_PHONE = 'verify-phone';
export const ALTERNATIVE_VERIFY_EMAIL = 'alternative-verify-email';
export const AUTHENTICATE_PHONE = 'authenticate-phone';
export const ALTERNATIVE_AUTHENTICATE_PHONE = 'alternative-authenticate-phone';
export const VERIFY_EMAIL = 'verify-email';
export const ALTERNATIVE_VERIFY_PHONE = 'alternative-verify-phone';
export const AUTHENTICATE_EMAIL = 'authenticate-email';
export const ALTERNATIVE_AUTHENTICATE_EMAIL = 'alternative-authenticate-email';
export const REGISTRATION_PRE_FINISH_PATH = 'consents';
export const SOCIAL_LOGIN_PRE_FINISH_PATH = 'complete';
export const SOCIAL_LOGIN_CONFLICT_ERROR_PATH = 'conflict-error';
export const LOGIN_WITH_PASSWORD_PATH = 'password';
export const REGISTRATION_WITH_PASSWORD_PATH = 'set-password';
export const GENERIC_ERROR_PATH = 'error';
export const UNRECOVERABLE_ERROR_PATH = 'unrecoverable-error';
export const SESSION_EXPIRED_PATH = 'session-expired';
export const VERIFY_PATH = 'verify';
export const VERIFY_CODE_QUERY_PARAM = 'code';
export const VERIFIED_PATH = 'verified';
export const CHANNEL_UNVERIFIED_ERROR_PATH = 'channel-unverified-error';
export const FORGOT_PASSWORD_PATH = 'forgot-password';
export const PASSWORD_RECOVERY_PATH = 'password-recovery';
export const PASSWORD_RECOVERY_LINK_EXPIRED_PATH = 'password-recovery-link-expired';
export const UNABLE_TO_RESET_PASSWORD_ERROR_PATH = 'unable-to-reset-password-error';

export const AUTH_MODULE_ROOT_PATH = 'auth';
